import styled from "@emotion/styled";
import Box from "@mui/material/Box";
import {
  COLOR_PRIMARY_BACKGROUND,
  COLOR_GREY_2,
  COLOR_PRIMARY_MAIN,
} from "shared/theme/colors";
import { border, flex } from "shared/theme/mixins";

export const StyledContainer = styled(Box, {
  shouldForwardProp: (propName) => !["isDisabled"].includes(propName),
})<{ isDisabled?: boolean }>`
  ${flex({ fd: "column" })};
  width: 100%;
  opacity: ${({ isDisabled }) => (isDisabled ? "0.4" : "1")};
`;

export const StyledContentContainer = styled(Box, {
  shouldForwardProp: (propName) => !["isActive"].includes(propName),
})<{ isActive: boolean }>`
  cursor: pointer;
  ${({ isActive }) => border(1, isActive ? COLOR_PRIMARY_MAIN : "transparent")};
  ${flex({ jc: "center", ai: "center" })};
  height: 126px;
  border-radius: 0.5rem;
  background-color: ${({ isActive }) =>
    isActive ? COLOR_PRIMARY_BACKGROUND : COLOR_GREY_2};
  margin-bottom: 5px;
`;
